import React from 'react';
import {useSelector} from 'react-redux';
import {getImageUrlById} from "../actions/networkActions";
import {getTranslation} from "../translations/translationUtils";
import {Tag} from "../resources/styles";

function ExcursionTags(props) {
    const tags = useSelector(state => state.excursionTags);

    return (
        <div className="relative">
            <ul className="m-0 list-style-none">
                {props.attributes.map((attribute, index) => (
                    <li key={index} className={props.displayInline ? "mt-2 mr-4 inline-block" : "mt-2 flex items-center" } >
                        {/* icon if exists */}
                        {tags && tags[attribute.code] &&
                            <>
                            { props.displayInline ?
                                <img src={getImageUrlById(tags[attribute.code], {width: 50})} alt=""/>
                                :
                                <Tag>
                                    <img src={getImageUrlById(tags[attribute.code], {width: 64})} alt=""/>
                                </Tag>
                            }
                            </>
                        }

                        {/* label*/}
                        { !props.displayInline &&
                            <span>
                                {attribute.tagName ? getTranslation(attribute.tagName) : attribute.name}
                            </span>
                        }
                    </li>)
                )}
            </ul>
        </div>
    )
}

export default ExcursionTags;
